import { createTheme, MuiThemeProvider } from '@material-ui/core';
import {
  createTheme as createNewTheme,
  ThemeProvider as V0ThemeProvider,
} from '@mui/material/styles';
import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import history from '../../services/history';
import store, { persistor } from '../../store';
import Routes from '../__Routes';
import colors from '../../assets/styles/colors';
import commons from '../../assets/styles/commons';

const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary.orange,
    },
  },
});

const materialTheme = createNewTheme({
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: commons.fontFamily,
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: `${colors.primary.orange} !important`,
          },
          '&:hover': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 0,
            },
          },
          '.MuiInputBase-input': {
            boxShadow: 'none !important',
            color: colors.neutral.gray,
          },
          '.MuiPickersPopper-root': {
            '.MuiDateCalendar-root': {
              border: `1px solid ${colors.primary.orange}`,
            },
          },
          '.MuiButtonBase-root': {
            '& svg path': {
              fill: colors.primary.orange,
            },
            '&.css-1e6y48t-MuiButtonBase-root-MuiButton-root': {
              color: `${colors.primary.orange} !important`,
            },
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: colors.primary.orange,
        }
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '.MuiMultiSectionDigitalClock-root': {
            width: '240px',
            justifyContent: 'center',
          },
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          '.MuiPickersPopper-paper': {
            boxShadow: 'none',
            border: `1px solid ${colors.primary.orange}`,
            marginTop: '8px',
          },
          '.MuiPickersCalendarHeader-root': {
            padding: '0px',
            '.MuiPickersCalendarHeader-labelContainer': {
              margin: '0',
              flex: '1',
              justifyContent: 'center',
              '.MuiButtonBase-root': {
                display: 'none',
              },
              '.MuiPickersCalendarHeader-label': {
                fontSize: commons.fontSize.xSmall,
                fontWeight: 700,
                fontFamily: commons.fontFamily,
                color: colors.neutral.gray,
              },
            },
            '.MuiPickersArrowSwitcher-root': {
              width: '-webkit-fill-available',
              justifyContent: 'space-between',
              position: 'absolute',
              '.MuiButtonBase-root': {
                '.MuiSvgIcon-root': {
                  fill: `${colors.primary.orange}`,
                },
              },
            },
          },
          '.MuiDateCalendar-root': {
            paddingBottom: '14px',
            height: 'max-content',
          },
          '.MuiDayCalendar-root': {
            '.MuiDayCalendar-slideTransition': {
              minHeight: '200px',
            },
            '.MuiTypography-root': {
              fontSize: '0.75rem',
              fontWeight: 800,
              colors: '#2E3A59',
              fontFamily: `${commons.fontFamily}`,
            },
            '.MuiPickersDay-root': {
              width: '41px',
              height: '32px',
              borderRadius: '4px',

              '&.MuiPickersDay-today': {
                border: 'none',
                borderBottom: `2px solid ${colors.primary.orange} !important`,
                borderRadius: '4px 4px 0 0',
              },
              '&.Mui-selected': {
                background: `${colors.primary.orange}`,
                borderRadius: '4px',
              },
              // '&:focus': {
              //   '&:not(.Mui-selected)': {
              //     background: 'rgb(255 114 6 / 0.1)',
              //   },
              // },
              '&:hover': {
                '&:not(.Mui-selected)': {
                  background: 'rgb(255 114 6 / 0.1)',
                },
              },
            },
            '.MuiDayCalendar-header': {
              justifyContent: 'space-evenly',
            },
            '.MuiPickersSlideTransition-root': {
              overflowX: 'initial',
            },
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          width: 'max-content !important',
          '&:first-child': {
            paddingRight: '2rem',
          },
          '&:last-child': {
            paddingLeft: '2rem',
          },
          '.MuiButtonBase-root': {
            borderRadius: '8px',
            '&.Mui-selected': {
              background: colors.primary.softOrange,
              '&:hover': {
                background: colors.primary.brightOrange,
              },
            },
            '&:hover': {
              background: colors.primary.lightOrange,
            },
          },
          '::-webkit-scrollbar': {
            width: '0',
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          '.MuiButtonBase-root': {
            color: colors.primary.brightOrange,
            '&:hover': {
              background: colors.primary.lightOrange,
            },
          },
        },
      },
    },
  },
});

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <MuiThemeProvider theme={theme}>
          <V0ThemeProvider theme={materialTheme}>
            <Router history={history}>
              <Routes />
            </Router>
          </V0ThemeProvider>
        </MuiThemeProvider>
        <ToastContainer limit={3} />
      </PersistGate>
    </Provider>
  );
};

export default App;
